import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { Box, Button, Typography } from '@mui/material';

import { Card } from 'components/TeamOverview/components/Common/Card/Card';
import { AiTool } from 'components/pages/AppLibrary/components/AiTool';

import { useQueryError } from 'utilities/hooks/useQueryError/useQueryError';
import { useGetAIToolsContentQuery } from 'store/apis/cmsApi';
import { useRecommendedAIToolsStyles } from 'components/TeamOverview/components/RecommendedAITools/styles';

import { aiToolsSelector } from 'store/slices/cmsSlice';

import { AI_MODELS } from 'components/AITools/constants/common';
import { ERROR_FETCHING_AI_TOOLS_MESSAGE } from 'components/pages/AppLibrary/constants';
import { APP_LIBRARY } from 'constants/urls';

export const RecommendedAITools = () => {
  const { error: AIContentError } = useGetAIToolsContentQuery();
  const aiToolsData = useSelector(aiToolsSelector);
  const history = useHistory();
  const { classes } = useRecommendedAIToolsStyles();

  const filteredAITools = aiToolsData
    .filter(
      (tool) =>
        tool.toolId === AI_MODELS.aira || tool.toolId === AI_MODELS.autoQC,
    )
    .slice(0, 2);

  useQueryError(AIContentError, ERROR_FETCHING_AI_TOOLS_MESSAGE);

  const redirectToAppLibrary = () => {
    history.push(APP_LIBRARY);
  };

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Recommended tools</Typography>
      <Box className={classes.toolsContainer}>
        {filteredAITools.map((tool) => (
          <Card key={tool.id} cardClass={classes.cardClass}>
            <AiTool aiTool={tool} />
          </Card>
        ))}
      </Box>
      <Button
        color="primary"
        variant="contained"
        className={classes.btn}
        onClick={redirectToAppLibrary}
      >
        Show all tools
      </Button>
    </Box>
  );
};
